module.exports = __webpack_public_path__ + "img/distribution.79893ad7.svg";